'<template>
  <div>
    <div v-if="!ready" class="loader"></div>
    <div v-else id="app" :class="{ [step]: true }">
      <!-- splash -->
      <div
        v-if="step === 'poster'"
        class="splash z3 flex justify-center items-center"
        :class="{
          'bg-white': ['2', 'all'].includes(query.p) || bg === 'white',
        }"
        @click="step = 'list'"
      >
        <div class="relative">
          <img :src="poster" alt="點單poster" />
          <button class="start-btn">
            <span class="button-inner">
              <p>開始落單</p>
            </span>
          </button>
        </div>
      </div>
      <!-- restaurant-container -->
      <div
        :class="{
          hide: step !== 'list',
        }"
        class="
          navbar
          flex
          justify-start
          items-center
          fixed
          top-0
          left-0
          right-0
          bg-white
          z2
        "
      >
        <img
          v-if="!useFeaturedImg"
          class="logo"
          src="data:image/png;base64,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"
        />
        <img
          v-else
          class="logo featured-img"
          src="https://res.cloudinary.com/dimorder/image/upload/v1605091575/Group_52_fy8zno.png"
        />
        <span v-if="table">枱號: {{table}}</span>
      </div>
      <section
        :class="{
          hide: step !== 'list',
        }"
        class="restaurant-container"
      >
        <span></span>
        <ul class="vendor-list">
          <li v-for="(restaurant, i) of restaurants" :key="i">
            <a @click="restaurantOnClick(restaurant)">
              <figure class="vendor-tile item">
                <picture>
                  <div
                    class="vendor-picture"
                    :style="{
                      backgroundImage: `url(&quot;${restaurant.img}&quot;)`,
                    }"
                  ></div>
                </picture>
                <figcaption class="vendor-info">
                  <span class="headline">
                    <span class="name fn">{{ restaurant.name }}</span>
                  </span>
                </figcaption>
              </figure>
            </a>
          </li>
        </ul>
      </section>

      <div v-if="modalIsOpen" class="modal">
        <div class="mask"></div>
        <div class="wrap" @click.self="modalIsOpen = false">
          <div class="modal-card">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">{{ merchant.name }}</div>
              </div>
              <div class="modal-body">
                <div
                  style="min-height: 250px; max-height: 646px; overflow: scroll"
                >
                  <img :src="merchant.img" width="100%" alt />
                </div>
              </div>
              <div class="modal-footer">
                <div
                  class="modal-button-group-v modal-button-group-normal"
                  role="group"
                >
                  <a
                    class="modal-button"
                    role="button"
                    target="_blank"
                    v-for="button in merchant.buttons[source]"
                    :key="button.label"
                    @click="openLink(button.url)"
                    >{{ button.label }}</a
                  >
                  <a
                    class="modal-button"
                    role="button"
                    @click.self="modalIsOpen = false"
                    >返回</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const sourceMap = {
  w: "wifinity",
  l: "leaflet",
  p: "poster",
  t: "tissue",
  f: "facebook",
  i: "instagram",
  r1: "referral1",
  r2: "referral2",
  r3: "referral3",
  r4: "referral4",
  r5: "referral5",
};
/**
 * Adds a query parameter to the given URL.
 *
 * @param {string} url - The URL to modify.
 * @param {string} key - The key of the query parameter to add.
 * @param {string} value - The value of the query parameter to add.
 * @returns {string} - The modified URL with the query parameter added.
 */
function addQueryParamToUrl(url, key, value) {
  const separator = url.includes("?") ? "&" : "?";
  const param = `${key}=${value}`;
  return `${url}${separator}${param}`;
}
function getValidButtons(buttons){
  return buttons.filter(b=>b.label&&b.url)
}

export default {
  name: "App",
  data() {
    return {
      bg: "",
      ready: false,
      step: "poster", // list
      modalIsOpen: false,
      list: [],
      merchant: {},
      restaurants: [],
      query: {},
      useFeaturedImg: false,
      table:"",

      source: "default",
      poster: "",
      defaultPoster:
        "https://res.cloudinary.com/order/image/upload/c_scale,w_576/v1582321997/Coronavirus_Poster_2_-1_qbiwvi.jpg",
    };
  },
  components: {},
  async created() {
    // https://list.dimorder.com?w=1&d=wc&u=medic
    // query param explain:
    // s=, source, means the source enter this page, eg: instagram, facebook
    // p=, poster, means use which poster. refer to sheet - Background
    // d=, district, means district, refer to sheet - District, Directory
    // t=, table number, pass this parameter to button click url

    const query = this.getQueryObject();
    const district = this.getDistrict();
    const poster = this.getPoster();

    if (district === "all") {
      this.useFeaturedImg = true;
    }

    this.query = query;
    this.source = sourceMap[query.s] ? sourceMap[query.s] : "default";
    // call api
    const r = await axios.get(
      "https://script.google.com/macros/s/AKfycbxUXWYqpRop2rX1wzEBIysOnf_elmsbLslgjP58JM__Yecx1o_3e--Wr276rW_9t6peEg/exec?" +
        `d=${district}&p=${poster}`
    );
    this.ready = true;
    this.poster = r.data.poster || this.defaultPoster;
    this.bg = r.data.bg;
    this.restaurants = r.data.restaurants.filter(
      (restaurant) =>
        restaurant.buttons[this.source].filter((o) => o.label).length
    );
    this.table = query.t

    console.log("district", this.district);
    console.log("poster", this.poster);
    if (
      this.poster ===
      "https://res.cloudinary.com/dimorder/image/upload/w_414/v1609295214/email/WhatsApp_Image_2020-12-30_at_10.26.10_AM_irerqf.jpg"
    ) {
      this.step = "list";
    }
    setTimeout(() => {
      this.step = "list";
    }, 2500);
  },
  methods: {
    getPoster() {
      const query = this.getQueryObject();
      let p = query.p;
      if (!p && window.location.host.match(/^rest\./)) {
        p = "all";
      }
      return p;
    },
    getDistrict() {
      const query = this.getQueryObject();
      let district = "wc";
      if (window.location.host.match(/^rest\./)) {
        district = "all";
      }
      if (query.d) {
        district = query.d;
      }
      return district;
    },
    restaurantOnClick(restaurant){
      this.openModal(restaurant)
      const buttons = getValidButtons(restaurant.buttons[this.source])
      if(buttons.length===1){
        this.openLink(buttons[0].url)
      }else{
        this.openModal(this.merchant)
      }
    },
    openModal(v) {
      this.modalIsOpen = true;
      this.merchant = v;
    },
    openLink(url) {
      const query = this.getQueryObject();
      if(query.t){
        url=addQueryParamToUrl(url, 't',query.t)
      }
      window.open(url);
    },
    getQueryObject() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      const entries = params.entries(); //returns an iterator of decoded [key,value] tuples
      let result = {};
      for (let entry of entries) {
        // each 'entry' is a [key, value] tupple
        const [key, value] = entry;
        result[key] = value;
      }
      return result;
    },
  },
  watch: {
    modalIsOpen: function (val) {
      if (val) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    },
  },
};
</script>

<style lang="scss">
@import "basscss";

$bg: #f2b924;

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.bg-white {
  background-color: white !important;
}
.o0 {
  opacity: 0;
}

.hide {
  position: fixed;
  top: -200vh;
}

body {
  margin: 0;
}
img {
  max-width: 100%;
}
svg {
  max-height: 100%;
}

html,
body {
  touch-action: manipulation;
  height: 100%;
}

#app {
  position: relative;
  &.list {
    @media only screen and (min-width: 768px) {
      max-width: 400px;
      margin: 0 auto;
    }
  }
  min-height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f9;
  @keyframes flash {
    50% {
      opacity: 0;
    }
  }

  .splash {
    cursor: pointer;
    width: 100vw;
    height: 100vh;
    background-color: #f2b924;
    &.bg-white {
      background-color: #fff;
    }
    .start-btn {
      appearance: none;
      animation: flash 2s infinite;
      // padding: 10vw 0;
      border-color: transparent;
      background-color: transparent;
      position: fixed;
      bottom: 20%;
      left: 0;
      width: 100%;
      font-size: 8vw;
    }
  }

  .navbar {
    @media only screen and (min-width: 768px) {
      max-width: 400px;
      margin: 0 auto;
    }
    user-select: none;
    color: #614d4a;
    height: 47px;
    .logo {
      width: 65px;
      margin-right: 10px;
      &.featured-img {
        width: 160px;
      }
    }
  }
  .restaurant-container {
    padding: 0 24px;
    padding-top: 79px;
    ul.vendor-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -8px -8px;
      padding: 0;
      list-style-type: none;
      a {
        cursor: pointer;
        text-decoration: none;
      }
      > li {
        // mobile
        max-width: calc(50% - 16px);
        width: calc(50% - 16px);

        margin: 0 8px 40px;
        flex: 1 1 auto;
        position: relative;
        list-style: none;
        figure.vendor-tile {
          // min-height: 200px;
          position: relative;
          margin: 0;
          z-index: 0;
          picture {
            position: relative;
            display: block;
            height: 120px;
            overflow: hidden;
            .vendor-picture {
              background: no-repeat center;
              background-size: contain;
              display: block;
              height: 100%;
              position: relative;
              z-index: 1;
              transition: transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
                opacity 150ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
            }
          }
          .vendor-info {
            display: block;
            padding: 8px 0 0;
            color: #707070;
            font-size: 1.4rem;
            position: relative;
            z-index: 2;
            .headline {
              display: flex;
              flex-flow: row nowrap;
              .name {
                text-align: center;
                flex: 1 1 auto;
                display: inline-block;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: normal;
                display: block;
                margin: 0;
                line-height: 1.3em;
                color: #333;
                font-size: 1rem;
                font-weight: normal;
                padding: 4px 0 0 0;
              }
            }
          }
        }
      }
    }
  }

  .modal {
    .mask {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      z-index: 999;
      background-color: rgba(0, 0, 0, 0.4);
    }
    .wrap {
      position: fixed;
      overflow: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      z-index: 999;
      -webkit-overflow-scrolling: touch;
      outline: 0;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-transform: translateZ(1px);
      transform: translateZ(1px);
      .modal-card {
        @media only screen and (min-width: 768px) {
          max-width: 400px;
        }
        width: 90% !important;
        .modal-content {
          border-radius: 7px;
          padding-top: 15px;
          position: relative;
          background-color: #fff;
          border: 0;
          background-clip: padding-box;
          text-align: center;
          height: 100%;
          overflow: hidden;
          .modal-header {
            padding: 6px 15px 15px;
          }
          .modal-body {
            padding: 0 15px 15px;
          }
          .modal-button {
            -webkit-touch-callout: none;
            position: relative;
            border-top: 1px solid #ddd;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            text-align: center;
            text-decoration: none;
            outline: none;
            color: #108ee9;
            font-size: 18px;
            height: 50px;
            line-height: 50px;
            display: block;
            width: auto;
            overflow: hidden;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:active {
              background: #ddd;
            }
          }
        }
      }
    }
  }
}

.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -55px;
  margin-left: -15px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid $bg;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>